import React from "react";
import styled from "styled-components";

// --- Data ---
const features = [
  {
    title: "AI Customization",
    description: "For real-time trip planning, You can design your own package with the Trippro AI",
    img: "https://cdn-icons-png.freepik.com/256/3849/3849099.png?uid=R180763786&ga=GA1.1.1046031348.1735292585&semt=ais_hybrid",
  },
  {
    title: "Book in Minutes",
    description: "Book your perfect trip instantly using TRIPPRO's AI-powered holiday planner",
    img: "https://cdn-icons-png.freepik.com/256/5911/5911537.png?uid=R180763786&ga=GA1.1.1046031348.1735292585&semt=ais_hybrid",
  },
  {
    title: "Transparent Pricing",
    description: "Our packages include clear breakdowns of costs, so you know exactly what you're paying for",
    img: "https://cdn-icons-png.freepik.com/256/10849/10849010.png?uid=R180763786&ga=GA1.1.1046031348.1735292585&semt=ais_hybrid",
  },
  {
    title: "Travel stress-free",
    description: "Enjoy round-the-clock support with a dedicated Single Point of Contact (SPOC) for all your needs",
    img: "https://cdn-icons-png.freepik.com/256/2200/2200326.png?uid=R180763786&ga=GA1.1.1046031348.1735292585&semt=ais_hybrid",
  },
];

// --- Styled Components ---

const Container = styled.section`
  padding: 4rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  overflow: hidden;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 3rem; /* Increased gap */
  max-width: 1400px; /* Increased max-width */
  width: 100%;
  align-items: center;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4rem; /* More space for 2 columns */
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

const CardWrapper = styled.div`
  display: flex;
  justify-content: center;
  
  /* Staggered effect for desktop */
  @media (min-width: 1025px) {
    &:nth-child(even) {
      margin-top: 6rem;
    }
  }
`;

const CircleCard = styled.div`
  width: 100%;
  max-width: 280px; /* Slightly larger max size */
  aspect-ratio: 1 / 1; /* Ensure perfect circle scaling */
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 10px 30px rgba(0, 78, 97, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem; /* Increased padding */
  transition: all 0.4s ease;
  cursor: pointer;
  position: relative;
  z-index: 1;

  &:hover {
    transform: translateY(-10px) scale(1.02);
    box-shadow: 0 20px 40px rgba(28, 168, 203, 0.2);
    border-color: #1CA8CB;
    background: rgba(255, 255, 255, 0.85);

    img {
      transform: scale(1.1);
    }
  }

  @media (max-width: 768px) {
    max-width: 240px;
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    max-width: 220px;
    padding: 1rem;
  }
`;

const Icon = styled.img`
  width: 50px;
  height: auto;
  margin-bottom: 1rem;
  transition: transform 0.3s ease;
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
`;

const Title = styled.h3`
  font-family: "Merriweather", serif;
  font-size: 1.1rem;
  font-weight: 700;
  color: #004e61;
  margin-bottom: 0.5rem;
  line-height: 1.3;
  padding: 0 10px;
`;

const Description = styled.p`
  font-family: "Poppins", sans-serif;
  font-size: 0.8rem;
  color: #555;
  line-height: 1.5;
  margin: 0;
  max-width: 200px;
`;

const SightSeeing = () => {
  return (
    <Container>
      <Grid>
        {features.map((feature, index) => (
          <CardWrapper key={index}>
            <CircleCard>
              <Icon src={feature.img} alt={feature.title} />
              <Title>{feature.title}</Title>
              <Description>{feature.description}</Description>
            </CircleCard>
          </CardWrapper>
        ))}
      </Grid>
    </Container>
  );
};

export default SightSeeing;
